class MapList {
    constructor() {
        let map = null;
        const markers = [];

        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("map", () => ({
                    DateHelper: {},
                    dialog: null,
                    dateData: {},

                    currentId: null,
                    listDates: {},
                    indexDates: [],

                    currentDate: null,
                    tomorrow: null,

                    CANCEL: 2,

                    init() {
                        window.alpineRender(this);

                        this.dialog =
                            document.querySelector(`[x-ref='listMap']`);

                        this.initDates();
                    },
                    initDates() {
                        this.currentDate = new Date();
                        this.tomorrow = new Date();
                        this.tomorrow.setDate(this.currentDate.getDate() + 1);

                        const formater = Intl.DateTimeFormat("fr-FR", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        });

                        const dates = Object.keys(this.listDates);

                        let prevDate = null;

                        for (const dateId of dates) {
                            this.indexDates.push(dateId);

                            const year = dateId.toString().slice(0, 4);
                            const month = dateId.toString().slice(4, 6);
                            const day = dateId.toString().slice(6, 8);

                            const date = new Date(year, month - 1, day);

                            this.dateData[dateId] = {
                                prev: prevDate,
                                mon: this.DateHelper.shortMonths[
                                    parseInt(month, 10)
                                ],
                                mday: parseInt(day, 10),
                                relative:
                                    this.getRelative(date) ??
                                    this.DateHelper.days[date.getDay()],
                                fullLabel: formater.format(date),
                                events: this.listDates[dateId].map((event) => ({
                                    location: event.geo.location,
                                    title: event.title,
                                    city: event.geo.city.name,
                                    eventId: event.eventId,
                                    date: event.date,
                                    isCanceled: event.canceled,
                                })),
                            };

                            if (prevDate) {
                                this.dateData[prevDate].next = dateId;
                            }
                            prevDate = dateId;
                        }
                    },

                    getRelative(date) {
                        if (
                            this.currentDate.getFullYear() ===
                                date.getFullYear() &&
                            this.currentDate.getMonth() === date.getMonth() &&
                            this.currentDate.getDate() === date.getDate()
                        ) {
                            return "Aujourd'hui";
                        }

                        if (
                            this.tomorrow.getFullYear() ===
                                date.getFullYear() &&
                            this.tomorrow.getMonth() === date.getMonth() &&
                            this.tomorrow.getDate() === date.getDate()
                        ) {
                            return "Demain";
                        }

                        return null;
                    },

                    openDialogMap(dateId) {
                        this.currentId = dateId;
                        if (!this.dialog.open) {
                            this.dialog.showModal();
                        }
                        this.render(dateId);
                    },
                    closeDialog() {
                        if (this.dialog.open) {
                            this.dialog.close();
                        }
                        map.remove();
                        map = null;
                    },
                    render(dateId) {
                        if (!map) {
                            map = L.map("map-leaflet", {
                                attributionControl: false,
                                zoomSnap: 0.1,
                                maxBoundsViscosity: 0.9,
                            });

                            const myAttrControl = L.control
                                .attribution()
                                .addTo(map);
                            myAttrControl.setPrefix(
                                '<a href="https://leafletjs.com/"  @click="closeDialog()">Leaflet</a>',
                            );

                            L.tileLayer(
                                "https://map.sopheos.com/{z}/{x}/{y}.png",
                                {
                                    maxZoom: 19,
                                    attribution:
                                        '&copy; <a href="http://www.openstreetmap.org/copyright" @click="closeDialog()">OpenStreetMap</a>',
                                },
                            ).addTo(map);
                        }

                        this.deleteMarkers();
                        this.addMarkers(dateId);

                        this.fitMarkers();
                    },

                    addMarkers(dateId) {
                        if (!this.listDates[dateId]) {
                            return;
                        }

                        L.Icon.Default.imagePath = "/map/";

                        this.dateData[dateId].events.forEach((event) => {
                            const marker = L.marker([
                                event.location.lat,
                                event.location.lon,
                            ]);
                            marker.bindPopup(
                                `
                                 <div class="flex flex-col gap-xs min-w-[200px]">
                                    <div class="flex flex-col gap-xs pr-md">
                                        <span class="max-w-form font-semibold text-large wrap-anywhere line-clamp-1">${event.city}</span>
                                        <span class="max-w-form wrap-anywhere line-clamp-1">${event.title}</span>
                                    </div>
                                    <div class="flex gap-xs ${event.isCanceled ? "justify-between" : "justify-end"}">
                                        <template x-if="${event.isCanceled}">
                                            <div class="rounded-xxs px-xs text-small self-start bg-red-600 font-semibold text-white">
                                                <span>Annulé</span>
                                            </div>
                                        </template>
                                        <a href="/evenement/${event.eventId}/${event.date}" class="text-nowrap" @click="closeDialog()">Voir le détail</a>
                                    </div>
                                </div>`,
                                { autoPan: false },
                            );
                            markers.push(marker);
                            marker.addTo(map);
                        });
                    },

                    deleteMarkers() {
                        markers.forEach((marker) => {
                            map.removeLayer(marker);
                        });
                        markers.length = 0;
                    },

                    fitMarkers() {
                        if (markers.length === 1) {
                            const bounds = markers[0]
                                .getLatLng()
                                .toBounds(5000);
                            map.fitBounds(bounds, {
                                maxZoom: 17,
                            });
                            map.setMaxBounds(bounds);
                        } else {
                            const group = new L.featureGroup(markers);
                            map.fitBounds(group.getBounds().pad(0.1), {
                                maxZoom: 17,
                            });
                            map.setMaxBounds(group.getBounds().pad(0.1));
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new MapList();
